export class MarkApprovedRequest {
  public comment: string | undefined;
}

export interface IMarkApprovedRequest {
  comment?: string;
  platformRequest?: boolean;
}
